import { CUSTOM_SECTION_BASE_ROUTE } from '@/src/utils/constants'
import React, { Suspense } from 'react'
import type { RouteObject } from 'react-router-dom'
import { LayoutMain } from '../../layouts/LayoutMain/LayoutMain'
import { AuthRoute } from '../../routes/routes.components'

const CustomSectionLazy = React.lazy(() => import('./CustomSection'))

const CustomSectionPage = (
  <Suspense fallback={<div />}>
    <CustomSectionLazy />
  </Suspense>
)

export const getCustomSectionRoutes = (): RouteObject[] => {
  return [
    {
      path: `${CUSTOM_SECTION_BASE_ROUTE}`,
      element: (
        <AuthRoute>
          <LayoutMain />
        </AuthRoute>
      ),
      children: [{ path: '', element: CustomSectionPage }],
    },
  ]
}
